module.exports = __webpack_public_path__ + "img/success-filled-dark.f6905de.svg";